import { FormRow, BigFormRow } from 'framework/ui/layout';
import { Checkbox } from 'framework/form';

const FeedbackAuthorCheckboxesForm = () => {
  const options = [
    {
      source: 'discussedWithColleague',
      label: 'Have you already discussed this feedback directly with the colleague?',
    },
    { source: 'prefersPersonalDelivery', label: 'Would you prefer to deliver this feedback personally?' },
    { source: 'needsHelp', label: 'Do you need help giving this feedback?' },
    { source: 'notCreateLogTimeTicket', label: 'Do not send me a ticket for time tracking after I submit my feedback' },
    {
      source: 'notifyRM',
      label: 'Notify People manager',
      tooltip:
        'Selecting this option sends a task to your People manager to review the feedback. Even if you don’t select it, the feedback is still visible in the worker’s profile.',
    },
  ];

  return (
    <FormRow colMd={12} colXl={12}>
      {options.map(option => (
        <BigFormRow key={option.source}>
          <Checkbox
            className="instance-feedback__task-checkbox"
            source={option.source}
            label={option.label}
            tooltip={option.tooltip}
          />
        </BigFormRow>
      ))}
    </FormRow>
  );
};

export default FeedbackAuthorCheckboxesForm;
